// React Query обвивките за изписванията, добавени с редизайна. Инвалидацията
// минава през `invalidateAll` (useInventory.ts) — единственото място; ключът на
// справката е под ["inventory", "writeoffs"], затова я хваща.
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  annulWriteoff,
  getWriteoffsReport,
  type WriteoffsReportParams,
} from "../api/inventoryWriteoffs";
import { invalidateAll } from "./useInventory";

export const useWriteoffsReport = (params: WriteoffsReportParams | null) =>
  useQuery({
    queryKey: ["inventory", "writeoffs", "report", params],
    queryFn: () => getWriteoffsReport(params!),
    enabled: !!params,
  });

export const useAnnulWriteoff = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: number; reason: string | null }) =>
      annulWriteoff(id, reason),
    onSuccess: () => invalidateAll(qc),
  });
};
